// ignite UI access
export const accessManagementView = 'accessmanagement.view';
export const accessManagementCreate = 'accessmanagement.create';
export const accessManagementEdit = 'accessmanagement.edit';
export const accessManagementDelete = 'accessmanagement.delete';
export const appsView = 'apps.view';

//access management
export const accessUsersView = 'tenantgroups.view';
export const accessGroupsView = 'tenantusers.view';

//cobranding
export const cobrandingView = 'cobranding.view';
export const cobrandingCreate = 'cobranding.create';
export const cobrandingEdit = 'cobranding.edit';
export const cobrandingDelete = 'cobranding.delete';

//dataentry
export const dataEntryView = 'dataentry.view';

//reporting
export const reportingView = 'reporting.view';

//monitoring
export const monitoringView = 'monitoring.view';

//schedules
export const schedulesView = 'schedules.view';
export const schedulesCreate = 'schedules.create';
export const schedulesEdit = 'schedules.edit';
export const schedulesDelete = 'schedules.delete';

//contact & app catalog
export const appCatalogView = 'appsmanagement.view';
export const appCatalogCreate = 'appsmanagement.create';
export const appCatalogEdit = 'appsmanagement.edit';
export const appCatalogDelete = 'appsmanagement.delete';

//sources
export const sourcesView = 'sources.view';
export const sourcesCreate = 'sources.create';
export const sourcesEdit = 'sources.edit';
export const sourcesDelete = 'sources.delete';
export const sourcesQueueJobs = 'sources.queuejobs';

//promotions
export const promotionsView = 'promotions.view';
export const promotionsTestCreate = 'promotions.test.create';
export const promotionsProdCreate = 'promotions.prod.create';
